// A helper that will merge partial values with existing object values
export function mergeWithPartial<A>(
  partialValues: Partial<A>,
  existingValues: A,
): A {
  return { ...existingValues, ...partialValues };
}
